import type { AxiosRequestConfig } from 'axios';
import axios from 'axios';

export type ExtendedAxiosRequest = AxiosRequestConfig & {
  _retry?: boolean;
};

class AuthApi {
  refreshToken = () => {
    const url = '/accesstoken/postrequestfornewtoken';
    const requestConfig: ExtendedAxiosRequest = {
      headers: {
        Accept: 'text/html,application/xhtml+xml,application/xml;q=0.9,*/*;q=0.8'
      },
      withCredentials: true,
      _retry: true
    };
    return axios.post(url, undefined, requestConfig);
  };
}

export default AuthApi;
